import * as http from '../../../vue_shared/http'
import {
  DocumentMetrics,
  DocumentPii,
  Documents,
  UpdatedReviewState
} from './state'

export async function getMetrics(): Promise<DocumentMetrics> {
  return http.get<DocumentMetrics>('/admin/document_dashboard/metrics')
}

export async function getDocumentPii(
  queryParams?: string
): Promise<DocumentPii> {
  return http.get<DocumentPii>(`/client/document_scans/filters${queryParams}`)
}

export async function updateDocReviewStatus(
  params: UpdatedReviewState
): Promise<UpdatedReviewState> {
  return http.put<UpdatedReviewState, UpdatedReviewState>(
    `/client/document_scans/${params.id}`,
    params
  )
}

export async function getDocumentList(queryParams: string): Promise<Documents> {
  return http.get<Documents>(`/client/document_scans${queryParams}`)
}

interface DocumentScan {
  id: number
  document_id: number
  review_status: string
  severity: string
  title: string
  document_path: string
  findings: {}
  file_size: number
  upload_date: Date
  visibility: string
  file_type: string
  pretty_id?: string
  request_path?: string
}
export async function getDocumentScan(id: number): Promise<DocumentScan> {
  return http.get<DocumentScan>(`/client/document_scans/${id}`)
}
